var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Block',{attrs:{"type":"form","icon":"block-form","id":_vm.id,"collections":_vm.collections,"show-controls":_vm.showControls,"searchable":_vm.searchable}},[_c('h2',{staticClass:"ag-block__title mt-1"},[_vm._v("Lead Gen Form")])])}
var staticRenderFns = []

export { render, staticRenderFns }